// TopicSection.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  Badge,
  Input
} from "reactstrap";
import { withTranslation } from "react-i18next";

import { Plus, List } from 'lucide-react';

import CardCarousel from './components/InfoProfileTopicCardCarousel';

import { uploadImage, fetchImage } from "utils/images/imageManager";

import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import axiosInstance from "utils/axiosInstance";


const TopicSection = ({ t, myInfoTopics, imageMap, handleAddNewTopic }) => {

  //--------------------------------------------------
  // Return
  //--------------------------------------------------

  return (

    <div className="d-block">
      <Row>
        <Col className="info-profile-carousel-col">
          <div className="d-flex justify-content-between align-items-center info-profile-section-header"
            style={{
              paddingLeft: "25px",
              marginBottom: "8px"
            }}
          >
            <p className="mb-0 info-profile-section-title">主題列表</p>

            <div className="d-flex">
              <Button
                color="info"
                onClick={handleAddNewTopic}
                style={{
                  width: "40px",
                  height: "40px",
                  padding: "8px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "6px",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
                }}
              >
                <Plus size={20} />
              </Button>

              <Button
                color="warning"
                onClick={()=>{}}
                style={{
                  width: "40px",
                  height: "40px",
                  padding: "8px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "15px",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
                }}
              >
                <List size={20} />
              </Button>
            </div>

          </div>
          <CardCarousel 
            cards={myInfoTopics}
            imageMap={imageMap}
          />
        </Col>
      </Row>

    </div>

  );
};

export default withTranslation()(TopicSection);


